import { render, staticRenderFns } from "./AScopeTransferField.vue?vue&type=template&id=500027cf&"
import script from "./AScopeTransferField.vue?vue&type=script&lang=js&"
export * from "./AScopeTransferField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports